import "../sass/app.scss";

import Animations from "./modules/Animations";
import initDigitalBrochureNavigation from "./modules/DigitalBrochureNavigation";
import initGlideCarousel from "./modules/GlideCarousel";
import initHeaderMobileCta from "./modules/HeaderMobileCta";

if (document.querySelector(".reveal")) {
  new Animations();
}
initDigitalBrochureNavigation();
initGlideCarousel();
initHeaderMobileCta();
